import * as tslib_1 from "tslib";
import { environment } from '../environment';
import { Http2Factory } from './http2-factory';
var Api = /** @class */ (function () {
    function Api(http2Factory) {
        this.http2Factory = http2Factory;
        /**
         * The only way to set a cookie on the other domains is to open an IFrame and make a request to that domain
         * and ask it to set a cookie itself. This method creates an iframe, sends the request, and then deletes the iframe.
         */
        this._pendingIFrames = [];
        this.http2 = http2Factory.create(environment.apiBaseUrl, environment.pdauthAppName, true);
    }
    Api.prototype.getAssetIds = function (intId, stringId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http2.graphqlRequest("\n                query GetAssets($intId: [Int], $stringId: [String]) {\n                    " + query + "\n                }\n        ", { intId: intId, stringId: stringId }, 'GET', '')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Api.prototype.pick = function (obj, props) {
        if (!obj) {
            return obj;
        }
        var retVal = {};
        for (var key in obj) {
            if (props.includes(key)) {
                retVal[key] = obj[key];
            }
        }
        return retVal;
    };
    Api.prototype.setCookieInIFrame = function (token, setCookieUrl) {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            if (token === null || token === undefined) {
                token = '';
            }
            var url = setCookieUrl + ("?value=" + token);
            var iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.style.display = 'none';
            iframe.style.height = '0';
            iframe.style.width = '0';
            iframe.style.opacity = '0';
            _this._pendingIFrames.push(iframe);
            iframe.onload = function (e) {
                resolve(e);
                document.body.removeChild(iframe);
                _this._pendingIFrames.splice(_this._pendingIFrames.indexOf(iframe), 1);
            };
            iframe.onerror = function (e) {
                resolve(e);
                console.error('Set cookie failed: ', e);
            };
            iframe.onabort = iframe.onerror;
            document.body.appendChild(iframe);
        });
    };
    return Api;
}());
export { Api };
